var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "course-request-form-wrap" },
    [
      !!_vm.response && _vm.warningMessage.length === 0
        ? [
            _c("br"),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "row",
                staticStyle: { "margin-left": "0", "margin-right": "0" }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "col-xs-12 alert",
                    class: {
                      "alert-danger": _vm.response.error,
                      "alert-success": !_vm.response.error
                    }
                  },
                  [
                    _vm.response.error
                      ? _vm._l(_vm.response.messages[0].VALIDATIONS, function(
                          message,
                          messageIndex
                        ) {
                          return _c("p", { key: messageIndex }, [
                            _vm._v(_vm._s(message.REASON))
                          ])
                        })
                      : _vm._l(_vm.response.messages, function(
                          message,
                          messageIndex
                        ) {
                          return _c("p", { key: messageIndex }, [
                            _vm._v(_vm._s(message))
                          ])
                        })
                  ],
                  2
                )
              ]
            )
          ]
        : _vm._e(),
      _vm._v(" "),
      !!_vm.selectedStudent
        ? [
            _vm.required.length === 0 &&
            _vm.elective.length === 0 &&
            _vm.mandatory.length === 0
              ? _c("div", [
                  _c("p", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "MAIN_CONTENT.CourseRequestForms.selectCourseRequestFormToComplete"
                        )
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "selector-wrap col-md-10 col-lg-6 col-md-offset-1 col-lg-offset-2"
                      },
                      [
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-sm-12 col-md-10" }, [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.selectedCourseForm,
                                    expression: "selectedCourseForm"
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  }
                                ],
                                staticClass: "form-control",
                                staticStyle: { "margin-top": "12px" },
                                attrs: {
                                  name: "Sapphire_Course_Request_Form",
                                  "aria-label": _vm.$t(
                                    "MAIN_CONTENT.CourseRequestForms.selectCourseRequestFormToComplete"
                                  )
                                },
                                on: {
                                  change: function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.selectedCourseForm = $event.target
                                      .multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  }
                                }
                              },
                              _vm._l(_vm.courseRequestList, function(
                                course,
                                courseIndex
                              ) {
                                return _c(
                                  "option",
                                  {
                                    key: "courseRequestList_" + courseIndex,
                                    domProps: { value: course }
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t\t" +
                                        _vm._s(course.FORM_DESC) +
                                        "\n\t\t\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              }),
                              0
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-xs-12 col-md-8 col-lg-8 col-md-offset-1"
                            },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-primary btn-block",
                                  attrs: {
                                    type: "button",
                                    disabled:
                                      Object.keys(_vm.selectedCourseForm)
                                        .length <= 0
                                  },
                                  on: { click: _vm.loadCoursesForGrade }
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t" +
                                      _vm._s(
                                        _vm.$t(
                                          "MAIN_CONTENT.CourseRequestForms.fillOutCourseRequestForm"
                                        )
                                      ) +
                                      "\n\t\t\t\t\t\t\t"
                                  )
                                ]
                              )
                            ]
                          )
                        ])
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-sm-12" }, [
                      !_vm.courseSelectionFrontPage
                        ? _c(
                            "div",
                            {
                              staticClass: "instructions alert alert-info",
                              staticStyle: { display: "inline-flex" }
                            },
                            [
                              _c(
                                "ol",
                                _vm._l(_vm.stepCount, function(step, index) {
                                  return _c("li", { key: "steps_" + index }, [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t" +
                                        _vm._s(
                                          _vm.$t(
                                            "MAIN_CONTENT.CourseRequestForms.courseRequestFormInstructionStep" +
                                              step
                                          )
                                        ) +
                                        "\n\t\t\t\t\t\t\t"
                                    )
                                  ])
                                }),
                                0
                              )
                            ]
                          )
                        : _c("div", {
                            staticClass: "instructions alert alert-info",
                            staticStyle: { display: "inline-flex" },
                            domProps: {
                              innerHTML: _vm._s(_vm.courseSelectionFrontPage)
                            }
                          })
                    ])
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.required.length > 0 ||
            _vm.mandatory.length > 0 ||
            _vm.elective.length > 0
              ? [
                  _vm.warningMessage.length > 0
                    ? _c(
                        "div",
                        {
                          staticClass: "alert alert-warning",
                          attrs: { role: "alertdialog" }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t" +
                              _vm._s(_vm.warningMessage) +
                              "\n\t\t\t"
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "credits-total" }, [
                    _vm._v(
                      "\n\t\t\t\t" +
                        _vm._s(
                          _vm.$t(
                            "MAIN_CONTENT.CourseRequestForms.creditsWithColon",
                            { count: _vm.creditCount }
                          )
                        ) +
                        "\n\t\t\t"
                    )
                  ]),
                  _vm._v(" "),
                  _vm.required.length > 0
                    ? [
                        _c("h2", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "MAIN_CONTENT.CourseRequestForms.requiredCourses"
                              )
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(_vm._s(_vm.selectedCourseForm.REQUIRED_DESC))
                        ]),
                        _vm._v(" "),
                        _c("required", {
                          attrs: {
                            departments: _vm.required,
                            selectedCourseForm: _vm.selectedCourseForm
                          },
                          on: { dataChanged: _vm.setChangedData }
                        })
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.mandatory.length > 0
                    ? [
                        _c("h2", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "MAIN_CONTENT.CourseRequestForms.mandatoryCourses"
                              )
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(_vm._s(_vm.selectedCourseForm.MANDATORY_DESC))
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.mandatory, function(
                          department,
                          departmentIndex
                        ) {
                          return [
                            _c(
                              "div",
                              {
                                key:
                                  "department_" +
                                  department.DEPARTMENT_ID +
                                  "_" +
                                  departmentIndex,
                                staticClass: "panel panel-default pointer"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "panel-heading dark clearfix",
                                    on: {
                                      click: function($event) {
                                        department.SHOW = !department.SHOW
                                        _vm.valTest++
                                      }
                                    }
                                  },
                                  [
                                    _c("h3", { staticClass: "panel-title" }, [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t" +
                                          _vm._s(department.DEPARTMENT_DESC) +
                                          "\n\t\t\t\t\t\t\t"
                                      )
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _c("mandatory", {
                                  key: "mandatory_" + departmentIndex,
                                  attrs: {
                                    description: department.DEPARTMENT_DESC,
                                    department: department
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        })
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.elective.length > 0
                    ? [
                        _c("h2", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "MAIN_CONTENT.CourseRequestForms.electiveCourses"
                              )
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(_vm._s(_vm.selectedCourseForm.ELECTIVE_DESC))
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.elective, function(
                          department,
                          departmentIndex
                        ) {
                          return [
                            _c(
                              "div",
                              {
                                key:
                                  "department_" +
                                  department.DEPARTMENT_ID +
                                  "_" +
                                  departmentIndex,
                                staticClass: "panel panel-default pointer"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "panel-heading dark clearfix",
                                    on: {
                                      click: function($event) {
                                        department.SHOW = !department.SHOW
                                        _vm.valTest++
                                      }
                                    }
                                  },
                                  [
                                    _c("h3", { staticClass: "panel-title" }, [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t" +
                                          _vm._s(department.DEPARTMENT_DESC) +
                                          "\n\t\t\t\t\t\t\t"
                                      )
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _c("elective", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: department.SHOW,
                                      expression: "department.SHOW"
                                    }
                                  ],
                                  key: "elective_" + _vm.valTest,
                                  staticStyle: { cursor: "default" },
                                  attrs: {
                                    department: department,
                                    selectedCourseForm: _vm.selectedCourseForm
                                  },
                                  on: { dataChanged: _vm.setChangedData }
                                })
                              ],
                              1
                            )
                          ]
                        }),
                        _vm._v(" "),
                        _vm.selectedAlts.length > 1 &&
                        _vm.selectedCourseForm.USE_ALTERNATES_FLG === "Y"
                          ? [
                              _c(
                                "div",
                                { staticClass: "panel panel-default" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "panel-heading light clearfix"
                                    },
                                    [
                                      _c("h3", { staticClass: "panel-title" }, [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t" +
                                            _vm._s(
                                              _vm.$t(
                                                "MAIN_CONTENT.CourseRequestForms.rankAlternates"
                                              )
                                            ) +
                                            " "
                                        ),
                                        _c("br"),
                                        _vm._v(" "),
                                        _c("small", [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t\t" +
                                              _vm._s(
                                                _vm.$t(
                                                  "MAIN_CONTENT.CourseRequestForms.rankAlternatesInstructions"
                                                )
                                              ) +
                                              "\n\t\t\t\t\t\t\t\t"
                                          )
                                        ])
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "ul",
                                    { staticClass: "list-group" },
                                    [
                                      _c(
                                        "Draggable",
                                        {
                                          staticClass: "clickable",
                                          attrs: { draggable: ".drag-item" },
                                          model: {
                                            value: _vm.selectedAlts,
                                            callback: function($$v) {
                                              _vm.selectedAlts = $$v
                                            },
                                            expression: "selectedAlts"
                                          }
                                        },
                                        _vm._l(_vm.selectedAlts, function(
                                          altCourse,
                                          index
                                        ) {
                                          return _c(
                                            "li",
                                            {
                                              key: "altRank" + index,
                                              staticClass:
                                                "list-group-item drag-item"
                                            },
                                            [
                                              _c("img", {
                                                staticClass: "draghandle",
                                                staticStyle: {
                                                  cursor: "move",
                                                  float: "left",
                                                  "margin-top": "-3px"
                                                },
                                                attrs: {
                                                  src:
                                                    "/Sapphire/images/icons/move_up_down.gif",
                                                  title:
                                                    "Drag Up or Down to reorder columns.",
                                                  alt: "Drag"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "rank badge pull-left"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\t\t\t" +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "MAIN_CONTENT.CourseRequestForms.rankAlternatesRank",
                                                          { rank: index + 1 }
                                                        )
                                                      ) +
                                                      "\n\t\t\t\t\t\t\t\t\t"
                                                  )
                                                ]
                                              ),
                                              _vm._v(
                                                " \n\t\t\t\t\t\t\t\t\t" +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "MAIN_CONTENT.CourseRequestForms.rankAlternateCouses",
                                                      {
                                                        courseid:
                                                          altCourse.COURSE_ID,
                                                        coursedescription:
                                                          altCourse.COURSE_DESC
                                                      }
                                                    )
                                                  ) +
                                                  "\n\t\t\t\t\t\t\t\t\t"
                                              ),
                                              _c("input", {
                                                staticClass: "weight",
                                                attrs: {
                                                  type: "hidden",
                                                  input: (altCourse.ALTERNATE_WEIGHT =
                                                    _vm.selectedAlts.length -
                                                    index)
                                                },
                                                domProps: {
                                                  value:
                                                    _vm.selectedAlts.length -
                                                    index
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                { staticClass: "pull-right" },
                                                [
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\t\t\t" +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "MAIN_CONTENT.CourseRequestForms.rankAlternatesCredits",
                                                          {
                                                            credit:
                                                              altCourse.CREDITS
                                                          }
                                                        )
                                                      ) +
                                                      "\n\t\t\t\t\t\t\t\t\t"
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        }),
                                        0
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            ]
                          : _vm._e()
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.required.length > 0 ||
                  _vm.mandatory.length > 0 ||
                  _vm.elective.length > 0
                    ? [
                        _vm.warningMessage.length > 0
                          ? _c(
                              "div",
                              {
                                staticClass: "alert alert-warning",
                                attrs: { role: "alertdialog" }
                              },
                              [
                                _vm._v(
                                  "\n\t\t\t\t" +
                                    _vm._s(_vm.warningMessage) +
                                    "\n\t\t\t"
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "credits-total" }, [
                          _vm._v(
                            "\n\t\t\t\t" +
                              _vm._s(
                                _vm.$t(
                                  "MAIN_CONTENT.CourseRequestForms.creditsWithColon",
                                  { count: _vm.creditCount }
                                )
                              )
                          )
                        ])
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary pull-right",
                      attrs: { disabled: !!_vm.warningMessage },
                      on: { click: _vm.saveCourseRequestForm }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t" +
                          _vm._s(
                            _vm.$t("MAIN_CONTENT.commonContent.submitButton")
                          ) +
                          "\n\t\t\t"
                      )
                    ]
                  )
                ]
              : _vm._e(),
            _vm._v(" "),
            _c(
              "modal",
              {
                attrs: {
                  "modal-title": _vm.modalTitle,
                  show: _vm.showModal,
                  "dialog-size": "sm",
                  name: "courseRequestModal"
                },
                on: {
                  close: function($event) {
                    return _vm.closeModal()
                  }
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(modalProps) {
                        return _vm._l(_vm.modalContent, function(
                          message,
                          messageIndex
                        ) {
                          return _c(
                            "p",
                            {
                              key: messageIndex,
                              staticClass: "text-center text-muted"
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t" + _vm._s(message) + "\n\t\t\t\t"
                              )
                            ]
                          )
                        })
                      }
                    }
                  ],
                  null,
                  false,
                  307881604
                )
              },
              [
                _vm._v(" "),
                _c("template", { slot: "footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-transparent pull-right",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.closeModal()
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t" +
                          _vm._s(
                            _vm.$t("MAIN_CONTENT.commonContent.closeButton")
                          ) +
                          "\n\t\t\t\t"
                      )
                    ]
                  )
                ])
              ],
              2
            )
          ]
        : [
            _vm._v(
              "\n\t\t" +
                _vm._s(
                  _vm.$t(
                    "MAIN_CONTENT.commonContent.noStudentHasBeenSelectedWithPeriod"
                  )
                ) +
                "\n\t"
            )
          ],
      _vm._v(" "),
      _c(
        "form",
        {
          ref: "printForm",
          attrs: {
            action:
              "/PortalAPI/index.cfm/api/v1/course-request-forms/form/print",
            target: "printFrame",
            method: "POST"
          }
        },
        [
          _c("input", {
            attrs: { type: "hidden", name: "student_rid" },
            domProps: { value: _vm.selectedStudent.STUDENT_RID }
          }),
          _vm._v(" "),
          _c("input", {
            attrs: { type: "hidden", name: "form_id" },
            domProps: { value: _vm.selectedCourseForm.FORM_ID }
          }),
          _vm._v(" "),
          _c("input", {
            attrs: { type: "hidden", name: "token" },
            domProps: { value: _vm.$store.state.accessToken }
          }),
          _vm._v(" "),
          _c("input", {
            attrs: { type: "hidden", name: "client_id" },
            domProps: { value: _vm.$store.state.clientID }
          })
        ]
      ),
      _vm._v(" "),
      _c("iframe", {
        ref: "printFrame",
        staticClass: "hidden",
        staticStyle: { display: "hidden" },
        attrs: { name: "printFrame" }
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }